import { Box } from "@mui/material"
import { SCHEME_STATUS_CHIP } from "./constants"
import schemeTokens from "./tokens"

const SchemeStatusChip = ({ status }) => {
  const chip = SCHEME_STATUS_CHIP[status]
  if (!chip) return null

  return (
    <Box
      component="span"
      sx={{
        ...schemeTokens.text.eyebrow,
        display: "inline-block",
        px: 1,
        py: 0.4,
        borderRadius: schemeTokens.radius.pill,
        bgcolor: chip.bg,
        color: chip.color,
      }}
    >
      {chip.label}
    </Box>
  )
}

export default SchemeStatusChip
